import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import axios from "../../api/axios";
import { initGTM } from "../../utils/gtm";
import { setAppSettings } from "../../store/slices/settingsSlice";

/**
 * Boots the analytics stack:
 *  - fetches /company/settings once if appSettings is empty
 *  - initializes GTM (Consent Mode v2 + script injection) when
 *    analytics_enabled && gtm_container_id are present
 *
 * Idempotent on its own and the underlying `initGTM()` is also idempotent.
 * Rendered as a sibling of RouterProvider — no UI output.
 */
export default function AnalyticsBootstrap() {
  const dispatch = useDispatch();
  const appSettings = useSelector((s) => s.settings.appSettings);

  useEffect(() => {
    const hasSettings =
      appSettings && typeof appSettings === "object" && Object.keys(appSettings).length > 0;
    if (hasSettings) return;

    let cancelled = false;
    axios
      .get("/company/settings")
      .then((res) => {
        if (cancelled) return;
        if (res && res.data) dispatch(setAppSettings(res.data));
      })
      .catch(() => {
        /* swallow: analytics is best-effort, not blocking */
      });

    return () => {
      cancelled = true;
    };
  }, [appSettings, dispatch]);

  useEffect(() => {
    if (!appSettings) return;
    if (!appSettings.analytics_enabled) return;
    if (!appSettings.gtm_container_id) return;
    initGTM(appSettings.gtm_container_id);
  }, [appSettings]);

  return null;
}
